import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  container: (props) => ({
    '& input': {
      '&::placeholder': {
        color: theme.colors.nimbus,
        ...props?.style?.placeholder,
      },
    },
  }),
}));

export default useStyles;
